export interface WorldRule {
  id: string;
  title: string;
  content: string;
  enabled: boolean;
  tags: string[];
}
export const WORLD_RULES: WorldRule[] = [
  [
    "guild-rating",
    "公会星级",
    "星级表示公会对委托与怪物威胁的评估，不等同于怪物天然等级。",
  ],
  [
    "hunter-license",
    "狩猎许可",
    "猎人依照公会许可承接任务；越权狩猎、滥捕和破坏生态会被追责。",
  ],
  [
    "hr-career",
    "猎人资历",
    "HR 是公会认可的连续资历，晋升来自任务记录与考核通知。",
  ],
  [
    "workshop",
    "工房生态",
    "工房以合法素材、泽尼与技术加工装备，数值由配方和素材决定。",
  ],
  [
    "material-economy",
    "素材经济",
    "怪物素材由任务结算登记并进入工房体系，不凭叙事无限生成。",
  ],
  [
    "old-world",
    "旧大陆",
    "旧大陆是与新大陆相区分的称呼；官方没有公开可确定全部方位与国界的统一地图。",
  ],
  [
    "new-world",
    "新大陆",
    "新大陆调查以调查团据点和生态研究为中心，航程与地理不应擅自精确化。",
  ],
  [
    "forest-hills",
    "森林与丘陵",
    "林地、丘陵和洞窟构成多层生态，猎人应观察足迹与小型生物。",
  ],
  ["desert", "沙漠地区", "昼夜温差、水源和沙下活动塑造当地狩猎方式。"],
  ["swamp", "沼泽地区", "毒性环境、湿地与洞穴使补给和路线判断格外重要。"],
  [
    "snow",
    "雪山与冻土",
    "严寒、雪崩风险与高低差限制行动，热饮和保暖具有实际意义。",
  ],
  [
    "volcano",
    "火山地区",
    "熔岩、矿脉和酷热共同构成风险，矿物也是工房经济的一环。",
  ],
  [
    "island",
    "孤岛与水域",
    "海岸、密林与水域相连，生态变化不能只按陆地经验解释。",
  ],
  [
    "highlands",
    "陆珊瑚与瘴气生态",
    "相邻生态层可以通过食物和尸骸循环关联，但不可杜撰具体未证实机制。",
  ],
  [
    "settlements",
    "聚落自治",
    "村庄、港口与据点各有委托需求，公会承担跨地域协调而非统治一切。",
  ],
  [
    "institutions",
    "调查机构",
    "书士队、龙历院等机构各有作品语境；彼此关系只采用资料明确部分。",
  ],
  [
    "history",
    "历史边界",
    "不拼接未经官方确认的古代文明战争、统一年表或世界地图。",
  ],
  [
    "calendar",
    "龙历纪年",
    "可使用作品明确的龙历表述；缺少换算依据时不强行对应现实年份。",
  ],
  [
    "felyne",
    "艾露与梅拉露",
    "艾露等智慧种族是社会参与者与合作伙伴，不当作普通怪物或宠物处理。",
  ],
  [
    "food-chain",
    "生态位",
    "怪物行为应服务于栖息地、食物链、繁殖与领域逻辑，不只为战斗登场。",
  ],
  [
    "canonical",
    "正史边界",
    "只把主系列本篇及正统扩展的明确设定当作正史；Stories、Frontier、Online、联动和影视内容不混入。",
  ],
].map(([id, title, content]) => ({
  id,
  title,
  content,
  enabled: true,
  tags: ["MH", "正史"],
}));
export function selectWorldGuidance(input: string) {
  const hits = WORLD_RULES.filter(
    (r) =>
      r.enabled &&
      (input.includes(r.title) ||
        r.content
          .split(/[，。]/)
          .some((w) => w.length > 3 && input.includes(w))),
  );
  return (hits.length ? hits : WORLD_RULES.slice(0, 5))
    .map((r) => `- ${r.title}：${r.content}`)
    .join("\n");
}
